const backendURL = `${process.env.REACT_APP_BACKEND_URL}api`;

export const createVippsTransaction = (bookId: string, lovdataUserId: string, transactionId: string) => {
  return new Promise(function (resolve, reject) {
    const apiUrl = `${backendURL}/createvippspayment`;
    const data = {
      BookId: bookId,
      LovdataUserId: lovdataUserId,
      TransactionId: transactionId,
    };
    fetch(apiUrl, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "x-functions-key": process.env.REACT_APP_BACKEND_SECRET_KEY,
      },
      timeout: 60000, // 60 sec
    })
      .then(async function (data) {
        resolve(await ReadStream(data));
      })
      .catch(function (err) {
        reject(console.error("createVippsTransaction failed", err));
      });
  });
};

export const checkVippsTransaction = (transactionId: string) => {
  return new Promise(function (resolve, reject) {
    const apiUrl = `${backendURL}/checkvippspaymentstatus/transactionid/${transactionId}`;
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-functions-key": process.env.REACT_APP_BACKEND_SECRET_KEY,
      },
      timeout: 60000, // 60 sec
    })
      .then(async function (data) {
        resolve(await ReadStream(data));
      })
      .catch(function (err) {
        reject(console.error("checkVippsTransaction failed", err));
      });
  });
};

export const getBook = (bookId: string) => {
  return new Promise(function (resolve, reject) {
    const apiUrl = `${backendURL}/book/bookid/${bookId}`;
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-functions-key": process.env.REACT_APP_BACKEND_SECRET_KEY,
      },
      timeout: 60000, // 60 sec
    })
      .then(async function (data) {
        resolve(await ReadStream(data));
      })
      .catch(function (err) {
        reject(console.error("getBook failed", err));
      });
  });
};

export const getBookAndTransactionId = (bookId: string, lovdataUserId: string) => {
  return new Promise(function (resolve, reject) {
    const apiUrl = `${backendURL}/getbookandtransactionid`;
    const data = {
      BookId: bookId,
      LovdataUserId: lovdataUserId,
    };
    const json = JSON.stringify(data);
    fetch(apiUrl, {
      method: "POST",
      body: json,
      headers: {
        "Content-Type": "application/json",
        "x-functions-key": process.env.REACT_APP_BACKEND_SECRET_KEY,
      },
      timeout: 60000, // 60 sec
    })
      .then(async function (data) {
        resolve(await ReadStream(data));
      })
      .catch(function (err) {
        reject(console.error("getBookAndTransactionId failed", err));
      });
  });
};

export const lovdataUserIdValidation = (lovdataUserId: string) => {
  return new Promise(function (resolve, reject) {
    const apiUrl = `${backendURL}/lovdatauservalidation`;
    const data = {
      LovdataUserId: lovdataUserId,
    };
    const json = JSON.stringify(data);
    fetch(apiUrl, {
      method: "POST",
      body: json,
      headers: {
        "Content-Type": "application/json",
        "x-functions-key": process.env.REACT_APP_BACKEND_SECRET_KEY,
      },
      timeout: 60000, // 60 sec
    })
      .then(async function (data) {
        resolve(await ReadStream(data));
      })
      .catch(function (err) {
        reject(console.error("lovdataUserIdValidation failed", err));
      });
  });
};

export async function ReadStream(response: any) {
  const reader = response.body?.getReader();
  const decoder = new TextDecoder();
  let result = "";
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      const chunk = decoder.decode(value, { stream: true });
      result += chunk;
    }
    return JSON.parse(result);
  } catch (error) {
    console.error("Error reading the stream:", error);
  } finally {
    reader.releaseLock();
  }
}
